import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Input,
  MenuItem,
  Select,
  createStyles,
  makeStyles,
} from '@material-ui/core';
import { useNetworkObserver } from 'data-layer-cr/dist/network';
import { colors } from 'design-system';
import { REQUEST_PRICING } from 'src/store/quotation/requestIdentifiers';

export interface Plan {
  id: number;
  endorsementsCode: string;
  planDescription: string;
  productId: string;
}

interface SelectPlanIconProps {
  className?: string;
}

const SelectPlanIcon = ({ className }: SelectPlanIconProps) => (
  <FontAwesomeIcon
    icon={faChevronDown}
    fontSize="24px"
    className={className}
    style={{ color: colors.bright_turquoise }}
    aria-label="seleccionar el plan"
  />
);

interface SelectPlanProps {
  onChangeEndorsement: (codeEndorsement: string) => void;
  pricingPlans: Plan[];
  currentSelectedEndorsement: string;
  packageOption: number;
}

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      textAlign: 'center',
      '&:hover': {
        background: '#CEE8FF',
      },
      '&:focus': {
        background: '#CEE8FF',
      },
    },
  }),
);

const SelectPlan = ({
  onChangeEndorsement,
  pricingPlans,
  currentSelectedEndorsement,
  packageOption,
}: SelectPlanProps): JSX.Element => {
  const requestingQuotationState = useNetworkObserver(REQUEST_PRICING);
  const classes = useStyles();

  const selectedCode = pricingPlans.find(
    ({ productId }) => productId === currentSelectedEndorsement.split('/')[0],
  );

  return (
    <Select
      id={`select-${selectedCode?.productId}-${packageOption + 1}`}
      fullWidth
      disabled={requestingQuotationState === 'requesting'}
      input={
        <Input
          id={`input-${selectedCode?.productId}-${packageOption + 1}`}
          disableUnderline
          style={{
            marginTop: 10,
            marginBottom: 10,
            color: colors.madison,
            fontSize: '23px',
            fontWeight: 900,
            lineHeight: '30px',
            letterSpacing: '0.005em',
            textAlign: 'center',
          }}
        />
      }
      value={`${selectedCode?.productId}/${selectedCode?.endorsementsCode}`}
      onChange={(event) => onChangeEndorsement(event.target.value as string)}
      IconComponent={SelectPlanIcon}
    >
      {pricingPlans.map(
        ({ planDescription, id, endorsementsCode, productId }) => (
          <MenuItem
            id={`menu-item-${productId}`}
            value={`${productId}/${endorsementsCode}`}
            key={id}
            className={classes.root}
          >
            {planDescription}
          </MenuItem>
        ),
      )}
    </Select>
  );
};

export default SelectPlan;
